import { render } from "./HistIrrig.vue?vue&type=template&id=02024cc2&scoped=true"
import script from "./HistIrrig.vue?vue&type=script&lang=js"
export * from "./HistIrrig.vue?vue&type=script&lang=js"

import "./HistIrrig.vue?vue&type=style&index=0&id=02024cc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02024cc2"]])

export default __exports__